module.exports = __webpack_public_path__ + "img/howitworks_mobile_hero.e25ac710.jpg";